import React from 'react'
import LowerSalon from '../assets/images/LowerSalon.png'
import BowSeating from '../assets/images/BowSeating.png'
import Galley from '../assets/images/Galley.png'
import Helm from '../assets/images/Helm.png'

export const CharterOfferMainSection = () => {
  return (
    <div className="CharterOfferMainSection">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <div className="CharterOfferBox">
                <div className="CharterOfferimg">
                  <img src={LowerSalon} alt="LowerSalon" />
                </div>
                <div className="CharterOfferContent">
                  <h2>Lower Salon</h2>
                  <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                </div>
              
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
          <div className="CharterOfferBox">
                <div className="CharterOfferimg">
                  <img src={BowSeating} alt="BowSeating" />
                </div>
                <div className="CharterOfferContent">
                  <h2>Bow Seating</h2>
                  <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                </div>
              
            </div>
          </div>
        </div>
        
        <div className="row Secondrow">
          <div className="col-lg-6 col-sm-12">
            <div className="CharterOfferBox">
                <div className="CharterOfferimg">
                  <img src={Galley} alt="LowerSalon" />
                </div>
                <div className="CharterOfferContent">
                  <h2>Galley</h2>
                  <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                </div>
              
            </div>
          </div>
          <div className="col-lg-6 col-sm-12">
          <div className="CharterOfferBox">
                <div className="CharterOfferimg">
                  <img src={Helm} alt="BowSeating" />
                </div>
                <div className="CharterOfferContent">
                  <h2>Helm</h2>
                  <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                </div>
              
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  )
}